import moment from 'moment';

export default () => ({
	loading: false,
	terminals: [],
	deviationTypes: [],
	deviationCauses: [],
	deviationTypeEditId: null,
	deviationCauseEditId: null,
	showEditDeviationType: false,
	showEditDeviationCause: false,
	deviationTypeTemplate: {
		id: null,
		code: '',
		description: '',
		editedDate: {
			date: moment().format('YYYYMMDDHHmm'),
			hasTime: true,
			timeZone: 'Europe/Oslo'
		}
	},
	deviationCauseTemplate: {
		id: null,
		code: '',
		description: '',
		availableFor: '',
		editedDate: {
			date: moment().format('YYYYMMDDHHmm'),
			hasTime: true,
			timeZone: 'Europe/Oslo'
		}
	},

	deviationTypeTemplates: [],
	deviationCauseTemplates: []
});
